/* eslint-disable @typescript-eslint/no-explicit-any */
export const setKeyDownRemoveFilter = (event: any, gridInstance: any) => {
  if (gridInstance && event.key === 'x' && event.ctrlKey) {
    gridInstance.clearFiltering();
  }
};